import React from "react"
import { Col, Row } from "reactstrap"
import PropTypes from "prop-types"

const LocationTabs = ({ activeTab, toggleTab, isLease }) => {

    // Define tab configuration
    const tabs = [
        // { id: "1", label: "Current Data" },
        { id: "1", label: "Details" },
        // Conditionally insert Lease Payments
        ...(isLease ? [{ id: "2", label: "Lease Payments" }] : []),
        { id: "3", label: "Financials" },
        { id: "4", label: "Files & Documents" },
    ]

    return (
        <Row className="mt-3 justify-content-center">
            <Col xs="auto">
                <div
                    style={{
                        backgroundColor: "#3C3C3C", // Dark gray background from image
                        borderRadius: "50px",       // Fully rounded pill shape
                        padding: "5px",
                        display: "flex",
                        alignItems: "center",
                        boxShadow: "0 4px 6px rgba(0,0,0,0.3)" // Subtle shadow
                    }}
                >
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.id
                        return (
                            <div
                                key={tab.id}
                                onClick={() => toggleTab(tab.id)}
                                style={{
                                    padding: "10px 25px",
                                    borderRadius: "40px",
                                    cursor: "pointer",
                                    fontWeight: isActive ? "bold" : "500",
                                    fontSize: "15px",
                                    color: isActive ? "#000000" : "#A0A0A0", // Black if active, gray if inactive
                                    backgroundColor: isActive ? "#FFCA5C" : "transparent", // Gold if active
                                    transition: "all 0.3s ease",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {tab.label}
                            </div>
                        )
                    })}
                </div>
            </Col>
        </Row>
    )
}

LocationTabs.propTypes = {
    activeTab: PropTypes.string.isRequired,
    toggleTab: PropTypes.func.isRequired,
    isLease: PropTypes.bool,
}

export default LocationTabs